<template>
  <TheMainContent class="flex min-h-[50vh] items-center justify-center">
    <p class="body-1 text-center">Welcome to guest my orders</p>
  </TheMainContent>
</template>

<script lang="ts" setup>
import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'
</script>
